export default __webpack_public_path__ + "static/media/rosto-triste.98a7246a.svg";